const Logo = "/images/logos/opentakt_logo.png";
const LogSm = "/images/logos/logo_sm.png";

const SidebarLogo = "/images/logos/sidebar-logo.svg";
const SidebarLogoIcon = "/images/logos/sidebar-logo-sm.svg";

const FallBackImg = "/images/misc/no-image.png";
const BlurImage = "/images/misc/blur.webp";

const Banner1 = "/images/banners/banner-1.jpg";
const Banner2 = "/images/banners/banner-2.jpg";
const Banner3 = "/images/banners/banner-3.jpg";
const Banner4 = "/images/banners/banner-4.jpg";
const Banner5 = "/images/banners/banner-5.jpg";
const Banner6 = "/images/banners/banner-6.jpg";

const ModalCloseIcon = "/images/icons/x-circle.svg";
const ProjectEditIcon = "/images/icons/edit-inline.svg";
const NotFoundPageIcon = "/images/icons/404.svg";
const ForbiddenPageIcon = "/images/icons/403.svg";
const HardDeadLineIcon = "/images/icons/bill_empty.svg";

export const Logos = { Logo, LogSm, SidebarLogo, SidebarLogoIcon };
export {
  FallBackImg,
  BlurImage,
  ModalCloseIcon,
  ProjectEditIcon,
  NotFoundPageIcon,
  ForbiddenPageIcon,
  HardDeadLineIcon,
};

export const Banners = { Banner1, Banner2, Banner3, Banner4, Banner5, Banner6 };
